import React from 'react';

export function MySelectList({children, getMenuProps = () => {}, className = ''}) {
	
	return (
		<ul className={`dropdown-menu w-100 ${className}`} {...getMenuProps()}>
			{children}
		</ul>
	)
}